export const userTeamsSchema = {
  count: {
    type: "number"
  },
  viewPackageAccess: {
    type: "boolean"
  },
  viewStreamAccess: {
    type: "boolean"
  },
  viewadminFlag: {
    type: "boolean"
  },
  viewsysadminFlag: {
    type: "boolean"
  },
  teamsData: {
    type: "array",
    child: {
      active: {
        type: "string"
      },
      base_user_id: {
        type: "string"
      },
      created: {
        type: "string"
      },
      id: {
        type: "string"
      },
      last_activity: {
        type: "string"
      },
      name: {
        type: "string"
      },
      architect: {
        current: {
          type: "string"
        },
        max: {
          type: "string"
        }
      },
      nlp: {
        current: {
          type: "string"
        },
        max: {
          type: "string"
        }
      },
      total: {
        current: {
          type: "string"
        },
        max: {
          type: "string"
        }
      }
    }
  }
};
